<template>
  <div class="row-item ">
    <p @click="showEvents()">{{ artist.artist_name }}</p>
    <transition name="slide">
      <div v-show="expand">
        <TextField class="m1" :id="'partnerLink'" :value="link"></TextField>
        <v-card class="mx-auto" max-width="344">
          <v-card-title class="card-headline">
            {{ artist.artist_name }} {{ $t('events') }}
          </v-card-title>
          <v-card-actions>
            <template v-if="rssLists.items">
              <template v-if="rssLists.items.length > 0">
                <div class="rss-container">
                  <div v-for="list in rssLists.items" :key="list.artist_id">
                    <p>{{ list.title }}</p>
                    <p>{{ list.description }}</p>
                  </div>
                </div>
              </template>
              <template v-else>
                <div>
                  <p>{{ $t('no_events') }}</p>
                </div>
              </template>
            </template>
          </v-card-actions>
        </v-card>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: ["artist", "rssList"],
  data: function() {
    return {
      expand: false
    };
  },
  computed: {
    rssLists: function() {
      // console.log("this.rssList ", this.rssList);
      return this.rssList.filter(s => s.artist_id == this.artist.artist_id)[0];
    },

    link: function() {
      // console.log("Show link ", this?.rssLists?.feed.url);
      return this.rssLists?.feed?.url || "";
    }
  },
  methods: {
    showEvents() {
      this.$emit("get_rsslist", this.artist.artist_id);
      this.expand = !this.expand;
    }
  }
};
</script>
<style scoped>
.rss-container {
  display: flex;
  flex-direction: row;
}
.row-item {
  border-bottom: 1px solid #ccc;
  cursor: pointer;
  min-height: 32px !important;
  height: auto !important;
}
.card-headline {
  background-color: rgb(144, 168, 179);
  color: white;
  padding: 10px;
}
.row-item p {
  margin-bottom: 0px;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
